import { render, staticRenderFns } from "./FieldBorderAvatar.vue?vue&type=template&id=3c6a5859&scoped=true&lang=html&"
import script from "./FieldBorderAvatar.vue?vue&type=script&lang=js&"
export * from "./FieldBorderAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6a5859",
  null
  
)

export default component.exports